import React, { FC } from 'react'

import { FormInputToggle } from '../FormInputToggle'

interface SettingsSwitchProps {
  title: string
  name: string
  value: boolean
  onValueChange: () => void
}

const SettingsSwitch: FC<SettingsSwitchProps> = ({ title, name, value, onValueChange }) => {
  return (
    <div className="row justify-content-between">
      <span className="mt-2">{title}</span>
      <span className={'mt-2'}>
        <FormInputToggle name={name} value={value} onValueChange={onValueChange} />
      </span>
    </div>
  )
}

export default SettingsSwitch
